const AMPLITUDE_EXPERIMENT_CONTROL_NAME = 'control';
const AMPLITUDE_EXPERIMENT_VARIANT_NAME = 'treatment';
const AMPLITUDE_EXPERIMENT_VARIANT_NAME_2 = 'treatment-2';

export {
  AMPLITUDE_EXPERIMENT_CONTROL_NAME,
  AMPLITUDE_EXPERIMENT_VARIANT_NAME,
  AMPLITUDE_EXPERIMENT_VARIANT_NAME_2,
};
